export default __webpack_public_path__ + "static/media/logo.f479a0a2.svg";